import React,{useState} from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import { withRouter } from 'react-router';
import { callGET, callPOST, callPUT, callDELETE } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';
import Icons from '../../../Components/Icons/Icons';
import SearchForecast from './SearchForecast';
import EditTerritory from './EditTerritory';
import EditSubTerritory from './EditSubTerritory';
import EditTerritoryUsers from './EditTerritoryUsers';

const ViewForecast = (props) => {
  const [monthRecord,setMonthRecord] = useState(['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC']);
  const curState = props.curState;
  const territoryList = curState.territoryList;
  const roleList = curState.roleList;
  const forecastData = curState.forecastData;
  const forecastSettingsData = curState.forecastSettings;
  const hasTerritory = forecastSettingsData ? forecastSettingsData.has_territory_enabled : false;
  const editData = curState.editData;
  // console.log(forecastData);
  let mainTerrData = null;
  if(forecastData) {
    if(forecastData.selected_hierarchy) {
      mainTerrData = forecastData.selected_hierarchy;
    }
  }
  let passData = {};
  if(hasTerritory) {
    passData = {territory_hierarchy:territoryList};
  }else {
    passData = {role_hierarchy:roleList};
  }
  let mainTerName = mainTerrData ? mainTerrData.element_name : '';
  return (
    <div className="outerPort" style={{top:"5px",left:"0px"}}>
      <div className="card card-transparent mb-0">
      <div className="card-header p-2">
        <div className="card-title">  Forecast Summary </div>
      </div>
          <div className="card-body">
            
            {forecastData ?
            <Wrp>
            <div className="d-flex align-items-center justify-content-between">
              <h6 className=""> 
                {
                  mainTerrData ? 
                    mainTerrData.is_user === true ?
                      mainTerrData.user_name
                    :
                      mainTerrData.element_name 
                  : ''
                } 
              </h6>
              <div className="mb-1"> 
                <a className="mr-2" onClick={e=>props.toggleEditTerritory(JSON.stringify([mainTerrData]))}> 
                  <Icons iconType="Edit" />
                </a>
                <a onClick={e=>props.deleteForecast(forecastData.id)}>
                  <Icons iconType="Delete" />
                </a>
              </div>

            </div>
            <div className="row row-card-no-pd">
              <div className="col-sm-6 col-md-3">
                <div className="card card-stats card-round mb-0">
                  <div className="card-body p-0">
                    <div className="row">
                      <div className="col-12">
                          <div className="numbers text-center">
                            <p className="card-category"> Target </p>
                            <h4 className="card-title"> 
                              {
                                mainTerrData ? 
                                  mainTerrData.has_target === true ?
                                    mainTerrData.target_value 
                                  :
                                    'Target not set'
                                : 'Target not set'
                              } 
                            </h4>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-3">
                <div className="card card-stats card-round">
                  <div className="card-body p-0">
                    <div className="row">
                      <div className="col-12">
                        <a onClick={e=>props.getDeals(curState.tableRecords.pagination,true,mainTerrData.element_id,mainTerrData.is_user === true ? mainTerrData.user_id : '',mainTerName)} className="cursor-pointer">
                          <div className="numbers text-center dataForecast" >
                            <p className="card-category"> Achieved </p>
                            <h4 className="card-title"> {mainTerrData ? mainTerrData.achieved_value : '0.00'}{mainTerrData ? mainTerrData.achieved_count > 0 ? '('+mainTerrData.achieved_count+')' : '' : ''} </h4>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-3">
                <div className="card card-stats card-round">
                  <div className="card-body p-0">
                    <div className="row"> 
                      <div className="col-12">
                        <a onClick={e=>props.getDeals(curState.tableRecords.pagination,false,mainTerrData.element_id,mainTerrData.is_user === true ? mainTerrData.user_id : '',mainTerName)} className="cursor-pointer">
                          <div className="numbers text-center dataForecast">
                            <p className="card-category"> Pipeline Deal </p>
                            <h4 className="card-title"> {mainTerrData ? mainTerrData.pipeline_value : '0.00'}{mainTerrData ? mainTerrData.pipeline_count > 0 ? '('+mainTerrData.pipeline_count+')' : '' : ''} </h4>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {
                mainTerrData ? 
                  <div className="col-sm-6 col-md-3">
                    <div className="card card-stats card-round">
                      <div className="card-body p-0">
                        <div className="row"> 
                          <div className="col-12">
                              <div className="numbers text-center">
                                <p className="card-category"> Pipeline Shortage </p>
                                <h4 className="card-title"> {mainTerrData.pipeline_percent} </h4>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                : null
              }
            </div>
            {
              forecastData ? forecastData.hierarchy_forecasts ? forecastData.hierarchy_forecasts.length > 0 ?
              <Wrp>
              <div className="d-flex align-items-center justify-content-between">
                <h6 className=""> {hasTerritory ? 'Sub Territory' : 'Subordinate Roles' } </h6>
                <div className="mb-1"> 
                  <a href="#" className="mr-2" onClick={e=>props.toggleEditSubTerritory(JSON.stringify(forecastData.hierarchy_forecasts))}> 
                    <Icons iconType="Edit" />
                  </a> 
                </div>

              </div>
              <div className="table-responsive ">
                <div className="table-scroll">
                  <table className="table mb-0">
                     
                    <thead>
                      <tr className="border-top"> 
                        <th> Name </th>
                        <th> Target </th>
                        <th> Achieved </th> 
                        <th> Pipeline Deal </th>  
                        <th> Target Achieved </th> 
                        <th> Pipeline Shortage </th> 
                      </tr>
                    </thead>
                    <tbody>
                    {
                      
                      forecastData.hierarchy_forecasts.map((arr,i) => {
                        if(arr.parent_id !== 0 || arr.parent_id !== '0') {
                          return (
                            <tr>
                              <td> 
                              {
                                !arr.element_name.toLowerCase().startsWith('without') ?
                                  <a onClick={e=>props.getForecast(arr.element_id,JSON.stringify(passData))}> <span className="badge badge-info"> {arr.element_name} </span></a>
                                : 
                                  <a> {arr.element_name} </a>
                              }
                              </td>
                              <td> 
                                {
                                  arr.has_target === true ?
                                    arr.target_value
                                  : 'Target not set'
                                } 
                              </td>
                              <td onClick={e=>props.getDeals(curState.tableRecords.pagination,true,arr.element_id,'',mainTerName)} > {arr.achieved_value}{arr.achieved_count > 0 ? '('+arr.achieved_count+')' : ''} </td>
                              <td onClick={e=>props.getDeals(curState.tableRecords.pagination,false,arr.element_id,'',mainTerName)} > {arr.pipeline_value}{arr.pipeline_count > 0 ? '('+arr.pipeline_count+')' : ''} </td>
                              <td> {arr.achieved_percent} </td>
                              <td> {arr.pipeline_percent} </td>
                            </tr> 
                          )
                        }
                      })
                      
                    }

                    </tbody>
                                           
                  </table>
                </div>
              </div>
              </Wrp>
              : null : null : null
            }
            {
            forecastData ? 
            forecastData.user_forecasts ? 
            forecastData.user_forecasts.length > 0 ? 
            <Wrp>
            <div className="d-flex align-items-center justify-content-between  mt-5">
              <h6 className=""> {hasTerritory ? 'Territory Users' : 'Role Members' } </h6>
              <div className="mb-1"> 
                <a href="#" className="mr-2" onClick={e=>props.toggleEditTerritoryUser(JSON.stringify(forecastData.user_forecasts))}> 
                  <Icons iconType="Edit" />
                </a> 
              </div>

            </div>
            <div className="table-responsive ">
              <div className="table-scroll">
                <table className="table mb-0">
                   
                  <thead>
                    <tr className="border-top"> 
                      <th> Name </th>
                      <th> Target </th>
                      <th> Achieved </th> 
                      <th> Pipeline Deal </th>  
                      <th> Target Achieved </th> 
                      <th> Pipeline Shortage </th> 
                    </tr>
                  </thead>
                  <tbody>
                  {
                    forecastData.user_forecasts ? 
                    forecastData.user_forecasts.map((arr,i) => {
                      return (
                        // !arr.user_name.toLowerCase().startsWith('others') ?
                        <tr>
                          <td> 
                            {
                              !arr.user_name.toLowerCase().startsWith('others') ?
                                <a onClick={e=>props.getForecast(arr.element_id,JSON.stringify(passData),arr.user_id)}> <span className="badge badge-info"> {arr.user_name} </span></a>
                              : 
                                <a> {arr.user_name} </a>
                            } 
                            </td>
                          <td> 
                            {
                              arr.has_target === true ?
                                arr.target_value
                              : 'Target not set'
                            } 
                          </td>
                          <td onClick={e=>props.getDeals(curState.tableRecords.pagination,true,arr.element_id,arr.user_id,mainTerName)}> {arr.achieved_value}{arr.achieved_count > 0 ? '('+arr.achieved_count+')' : ''} </td>
                          <td onClick={e=>props.getDeals(curState.tableRecords.pagination,false,arr.element_id,arr.user_id,mainTerName)}> {arr.pipeline_value}{arr.pipeline_count > 0 ? '('+arr.pipeline_count+')' : ''} </td>
                          <td> {arr.achieved_percent} </td>
                          <td> {arr.pipeline_percent} </td>
                        </tr> 
                        // : null
                      )
                    })
                    : null
                  }

                  </tbody>
                                         
                </table>
              </div>
            </div>
            </Wrp>
            : null : null : null }
            </Wrp>
            : 
              <div className="row">
                <div className="col-md-8 mx-auto text-center">
                  Target not set. <a onClick={props.toggleNewForecast} className="cursor-pointer"><u> Set target now.</u></a>
                </div>
              </div>

             }
          </div>
      </div>
    </div>
  );
}

export default withRouter(ViewForecast);  